import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import TextEditor from 'components/TextEditor';
import * as actions from 'actions';
import { getCommentsTextEditing, getCommentsEmojis, getUserProfile } from 'selectors';

class ResourceCommentsTextEditor extends Component {

  render() {
    return (
      <TextEditor
       {...this.props}
       ref="textEditor"
       contentTitle={__('members.comments.editor.title')}
       hasMediumHeight
       allowsCanceling
       maxChars={process.env.KOOTH_MAX_CHARS}
       placeholder={__('members.comments.editor.placeholder')}
       onSubmit={(text) => this.props.onSubmit(text, this.props.userName)}
      />
    );
  }
}

ResourceCommentsTextEditor.propTypes = {
  resourceType: PropTypes.string,
  isForNewComments: PropTypes.bool,
  userName: PropTypes.string,
  onSubmit: PropTypes.func
};

const mapStateToProps = (state, props) => {
  const level = props.isForNewComments ? 'firstLevel' : 'secondLevel';
  const textEditing = getCommentsTextEditing(state, level);
  const userName = getUserProfile(state).userName;

  return {
    ...textEditing,
    isExpanded: textEditing.isExpanded || props.isExpanded,
    showsEmojis: getCommentsEmojis(state, level).areVisible,
    userName
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const level = props.isForNewComments ? 'firstLevel' : 'secondLevel';

  return {
    onTextUpdate: text => {
      dispatch(actions.commentUpdateText({ text, key: level }));
    },
    onSubmit: (text, userName) => {
      dispatch(actions.commentCreate(
        text,
        level,
        props.resourceType,
        props.resourceId,
        `Thanks ${userName}`,
        __('members.comments.successMessage')
      ));
      dispatch(actions.commentEmojisHide(level));
    },
    onFocus: () => {
      if(props.isForNewComments) {
        dispatch(actions.commentExpand(level));
      }
    },
    onCancel: () => {
      if(props.isForNewComments) {
        dispatch(actions.commentReset('firstLevel'));
      }
      else {
        dispatch(actions.commentReplyCancel());
      }

      dispatch(actions.commentEmojisHide(level));
    },
    onEmojisToggled: showsEmojis => {
      if(showsEmojis) {
        dispatch(actions.commentEmojisHide(level));
      }
      else {
        dispatch(actions.commentEmojisShow(level));
      }
    },
    onEmojiSelected: (text, emojiShortName, selectionStart) => {
      dispatch(actions.commentUpdateText({text, emojiShortName, selectionStart, key: level}));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceCommentsTextEditor);



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/ResourceCommentsTextEditor/index.js
 **/